import { graphql, useStaticQuery } from "gatsby"
import Media from "../types/media"

const useHeader = () => {
  const { allWpHeader } = useStaticQuery(graphql`
    query {
      allWpHeader(sort: { date: DESC }) {
        nodes {
          headeroptions {
            logo: headeroptionslogo {
              mediaItemUrl
              mimeType
              mediaType
              altText
              title
              gatsbyImage: localFile {
                childImageSharp {
                  gatsbyImageData(
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                    quality: 100
                    layout: FULL_WIDTH
                  )
                }
              }
            }
          }
        }
      }
    }
  `)
  return allWpHeader.nodes[0]
}

export default useHeader
